import React, { useLayoutEffect, useState } from "react";
import {
  Layout,
  Card,
  Row,
  Col,
  Form,
  Input,
  Button,
  Spin,
  InputNumber,
} from "antd";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import { postAPI, displayMessage } from "../../utils/common";
import {
  CREATE_SUBSCRIPTION_PLAN,
  EDIT_SUBSCRIPTION_PLAN,
  SUBSCRIPTION_PLAN_BY_ID,
} from "../../constants/api";
import { useNavigate, useParams } from "react-router-dom";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";

function SubscriptionPlanForm() {
  const { Content } = Layout;
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  useLayoutEffect(() => {
    if (id) getPlanDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPlanDetail = () => {
    setLoading(true);
    postAPI(
      SUBSCRIPTION_PLAN_BY_ID,
      { id },
      (res) => {
        if (res.status === true) {
          const plan = res.data;
          form.setFieldsValue({
            plan_name: plan.plan_name,
            plan_room_capacity_start: plan.plan_room_capacity_start,
            plan_room_capacity_end: plan.plan_room_capacity_end,
            plan_monthly_price: plan.plan_monthly_price,
            plan_yearly_price: plan.plan_yearly_price,
          });
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to fetch data");
        setLoading(false);
      },
    );
  };

  const handleSubmit = (values) => {
    setLoading(true);
    const api = id ? EDIT_SUBSCRIPTION_PLAN : CREATE_SUBSCRIPTION_PLAN;
    if (id) values.id = id;

    postAPI(
      api,
      values,
      (res) => {
        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          navigate("/master/subscription-plan");
        } else {
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
        setLoading(false);
      },
      () => {
        displayMessage(ERROR_MSG_TYPE, "Unable to save data");
        setLoading(false);
      },
    );
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card title={id ? "Edit Subscription Plan" : "Add Subscription Plan"}>
          <Spin spinning={loading}>
            <Form form={form} layout="vertical" onFinish={handleSubmit}>
              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <Form.Item
                    name="plan_name"
                    label="Plan Name"
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="plan_room_capacity_start"
                    label="Capacity From"
                    rules={[{ required: true }]}
                  >
                    <InputNumber min={1} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    name="plan_room_capacity_end"
                    label="Capacity To"
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      min={1}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="plan_monthly_price"
                    label="Monthly Price"
                    rules={[{ required: true }]}
                  >
                    <InputNumber
                      min={1}
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    name="plan_yearly_price"
                    label="Yearly Price"
                    rules={[{ required: true }]}
                  >
                    <InputNumber min={0} style={{ width: "100%" }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button type="primary" htmlType="submit" loading={loading}>
                    {id ? "Update" : "Create"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default SubscriptionPlanForm;
